// Serviços específicos para leilões e lances
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL || 'https://knorrleiloes.s3.us-east-2.amazonaws.com';

// Função para buscar lotes de um leilão específico
export const fetchLotesLeilao = async (leilaoId) => {
  try {
    console.log('Buscando lotes via API:', `${API}/knorr/leiloes/${leilaoId}`);
    
    const response = await axios.get(`${API}/knorr/leiloes/${leilaoId}`, {
      timeout: 35000, // 35 segundos para aguardar a API externa
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
    
    console.log('Resposta da API recebida:', response.data);
    
    // Retorna os dados mesmo se for array vazio
    return response.data || [];
    
  } catch (error) {
    console.error('Erro ao buscar lotes do leilão:', error);
    
    if (error.code === 'ECONNABORTED') {
      throw new Error('Timeout ao carregar os lotes. A API está demorando para responder.');
    }
    
    if (error.response) {
      // Erro de resposta HTTP
      if (error.response.status === 504) {
        throw new Error('Timeout na conexão com a API externa. Tente novamente.');
      } else if (error.response.status >= 500) {
        throw new Error('Erro interno do servidor da API externa. Tente novamente em alguns momentos.');
      } else if (error.response.status === 404) {
        throw new Error('Leilão não encontrado na API.');
      }
    }
    
    throw new Error('Não foi possível carregar os lotes do leilão. Verifique sua conexão e tente novamente.');
  }
};

// Função para obter imagens do lote
export const getLoteImageUrl = (loteId, imageNumber = 1) => {
  return `${S3_BASE_URL}/lote_${imageNumber}_img_${loteId}.jpg`;
};

// Função para obter imagens do lote usando os novos campos img_lote_1, img_lote_2, etc
export const getLoteImages = (lote) => {
  const images = [];
  
  // Verifica as 4 possíveis imagens usando os novos campos
  if (lote.img_lote_1) {
    images.push(lote.img_lote_1);
  }
  if (lote.img_lote_2) {
    images.push(lote.img_lote_2);
  }
  if (lote.img_lote_3) {
    images.push(lote.img_lote_3);
  }
  if (lote.img_lote_4) {
    images.push(lote.img_lote_4);
  }
  
  // Se não há imagens específicas, tenta o padrão antigo
  if (images.length === 0) {
    // Fallback para o sistema antigo
    if (lote.IMAGEM1 === 'S') {
      images.push(getLoteImageUrl(lote.ID, 1));
    }
    if (lote.IMAGEM2 === 'S') {
      images.push(getLoteImageUrl(lote.ID, 2));
    }
    if (lote.IMAGEM3 === 'S') {
      images.push(getLoteImageUrl(lote.ID, 3));
    }
    if (lote.IMAGEM4 === 'S') {
      images.push(getLoteImageUrl(lote.ID, 4));
    }
  }
  
  // Se ainda não há imagens, usa uma imagem padrão
  return images.length > 0 ? images : [getLoteImageUrl(lote.ID, 1)];
};

// Função para obter URL do vídeo do YouTube
export const getYouTubeEmbedUrl = (videoUrl) => {
  if (!videoUrl) return null;
  
  // Remove quebras de linha e espaços
  const cleanUrl = videoUrl.trim().replace(/[\r\n]/g, '');
  
  // Extrair ID do vídeo de diferentes formatos de URL do YouTube
  let videoId = null;
  
  // Formato: https://www.youtube.com/watch?v=VIDEO_ID
  if (cleanUrl.includes('youtube.com/watch?v=')) {
    const urlParams = new URL(cleanUrl);
    videoId = urlParams.searchParams.get('v');
  }
  // Formato: https://youtu.be/VIDEO_ID
  else if (cleanUrl.includes('youtu.be/')) {
    videoId = cleanUrl.split('youtu.be/')[1].split('?')[0];
  }
  // Formato: https://www.youtube.com/embed/VIDEO_ID
  else if (cleanUrl.includes('youtube.com/embed/')) {
    videoId = cleanUrl.split('embed/')[1].split('?')[0];
  }
  // Se for apenas o ID do vídeo
  else if (/^[a-zA-Z0-9_-]{11}$/.test(cleanUrl)) {
    videoId = cleanUrl;
  }
  
  if (!videoId) {
    console.error('Não foi possível extrair ID do vídeo de:', cleanUrl);
    return cleanUrl; // Retorna a URL original se não conseguir processar
  }
  
  console.log('ID do vídeo extraído:', videoId);
  return `https://www.youtube.com/embed/${videoId}?autoplay=0&rel=0&modestbranding=1&controls=1`;
};

// Função para formatar data de nascimento
export const formatDateOfBirth = (dateString) => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  } catch {
    return dateString;
  }
};

// Função para formatar sexo
export const formatSex = (catego) => {
  switch (catego) {
    case 'M': return 'Macho';
    case 'F': return 'Fêmea';  
    case 'C': return 'Castrado';
    case 'S': return 'Cobertura';
    default: return catego || '';
  }
};

// Função para determinar status do lote
export const getLoteStatus = (lote) => {
  // Lote está vendido se:
  // 1. Campo VENDIDO = 'S' OU
  // 2. LANATU >= LANMAX (apenas se LANMAX > 0)
  if (lote.VENDIDO === 'S' || (lote.LANMAX > 0 && lote.LANATU >= lote.LANMAX)) {
    return 'VENDIDO';
  }
  
  return 'ATIVO';
};

// Função para dar lance (implementação real)
export const darLance = async (loteId, valor, clienteId) => {
  try {
    console.log('Enviando lance para API:', { loteId, valor, clienteId });
    
    const response = await axios.post(`${API}/knorr/lances`, {
      clienteId: parseInt(clienteId),
      loteId: parseInt(loteId),
      valor: parseFloat(valor)
    }, {
      timeout: 15000, // 15 segundos
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
    
    console.log('Lance enviado com sucesso:', response.data);
    
    return {
      success: true,
      novoValor: valor,
      message: 'Lance realizado com sucesso!',
      data: response.data
    };
    
  } catch (error) {
    console.error('Erro ao enviar lance:', error);
    
    if (error.code === 'ECONNABORTED') {
      throw new Error('Timeout ao enviar lance. Tente novamente.');
    }
    
    if (error.response) {
      if (error.response.status === 400) {
        throw new Error('Dados do lance inválidos. Verifique as informações.');
      } else if (error.response.status === 409) {
        throw new Error('Lance duplicado ou conflito. Tente com um valor diferente.');
      } else if (error.response.status >= 500) {
        throw new Error('Erro interno do servidor. Tente novamente em alguns momentos.');
      } else {
        throw new Error(`Erro ao processar lance: ${error.response.data?.detail || error.response.statusText}`);
      }
    }
    
    throw new Error('Não foi possível processar o lance. Verifique sua conexão e tente novamente.');
  }
};